module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc_title"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "intro"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/introduction#intro1"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/introduction#ba1"
    }
  }, [_c('b', [_vm._v("c. 150 Million B.C.")]), _vm._v(" Ant Odometer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/introduction#ba2"
    }
  }, [_c('b', [_vm._v("c. 30 Million B.C.")]), _vm._v(" Primates Count")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/introduction#ba3"
    }
  }, [_c('b', [_vm._v("c. 1 Million B.C.")]), _vm._v(" Cicada-Generated Prime Numbers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/introduction#ba4"
    }
  }, [_c('b', [_vm._v("c. 100,000 B.C.")]), _vm._v(" Knots")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/introduction#ba5"
    }
  }, [_c('b', [_vm._v("c. 18,000 B.C.")]), _vm._v(" Ishango Bone")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/introduction#ba6"
    }
  }, [_c('b', [_vm._v("c. 3000 B.C.")]), _vm._v(" Quipu")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/introduction#ba7"
    }
  }, [_c('b', [_vm._v("c. 3000 B.C.")]), _vm._v(" Dice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/introduction#ba8"
    }
  }, [_c('b', [_vm._v("c. 2200 B.C.")]), _vm._v(" Magic Squares")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/introduction#ba9"
    }
  }, [_c('b', [_vm._v("c. 1800 B.C.")]), _vm._v(" Plimpton 322")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/introduction#ba10"
    }
  }, [_c('b', [_vm._v("c. 1650 B.C.")]), _vm._v(" Rhind Papyrus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/introduction#ba11"
    }
  }, [_c('b', [_vm._v("c. 1300 B.C.")]), _vm._v(" Tic Tac Toe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/introduction#ba12"
    }
  }, [_c('b', [_vm._v("c. 600 B.C.")]), _vm._v(" Pythagorean Theorem and Triangles")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab13"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/introduction#ba13"
    }
  }, [_c('b', [_vm._v("548 B.C.")]), _vm._v(" Go")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab14"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/introduction#ba14"
    }
  }, [_c('b', [_vm._v("c. 530 B.C.")]), _vm._v(" Pythagoras Founds Mathematical Brotherhood")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab15"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/introduction#ba15"
    }
  }, [_c('b', [_vm._v("c. 445 B.C.")]), _vm._v(" Zeno’s Paradoxes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab16"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/introduction#ba16"
    }
  }, [_c('b', [_vm._v("c. 440 B.C.")]), _vm._v(" Quadrature of the Lune")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab17"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/introduction#ba17"
    }
  }, [_c('b', [_vm._v("c. 350 B.C.")]), _vm._v(" Platonic Solids")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab18"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/introduction#ba18"
    }
  }, [_c('b', [_vm._v("c. 350 B.C.")]), _vm._v(" Aristotle’s "), _c('i', [_vm._v("Organon")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab19"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/introduction#ba19"
    }
  }, [_c('b', [_vm._v("c. 320 B.C.")]), _vm._v(" Aristotle’s Wheel Paradox")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab20"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/introduction#ba20"
    }
  }, [_c('b', [_vm._v("300 B.C.")]), _vm._v(" Euclid’s "), _c('i', [_vm._v("Elements")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab21"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/introduction#ba21"
    }
  }, [_c('b', [_vm._v("c. 250 B.C.")]), _vm._v(" Archimedes: Sand, Cattle & Stomachion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab22"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/introduction#ba22"
    }
  }, [_c('b', [_vm._v("c. 250 B.C.")]), _vm._v(" π")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab23"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/introduction#ba23"
    }
  }, [_c('b', [_vm._v("c. 240 B.C.")]), _vm._v(" Sieve of Eratosthenes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab24"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/introduction#ba24"
    }
  }, [_c('b', [_vm._v("c. 240 B.C.")]), _vm._v(" Archimedean Semi-Regular Polyhedra")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab25"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/introduction#ba25"
    }
  }, [_c('b', [_vm._v("225 B.C.")]), _vm._v(" Archimedes’ Spiral")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab26"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/introduction#ba26"
    }
  }, [_c('b', [_vm._v("c. 180 B.C.")]), _vm._v(" Cissoid of Diocles")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab27"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/introduction#ba27"
    }
  }, [_c('b', [_vm._v("c. 150")]), _vm._v(" Ptolemy’s "), _c('i', [_vm._v("Almagest")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab28"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/introduction#ba28"
    }
  }, [_c('b', [_vm._v("250")]), _vm._v(" Diophantus’s "), _c('i', [_vm._v("Arithmetica")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab29"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/introduction#ba29"
    }
  }, [_c('b', [_vm._v("c. 340")]), _vm._v(" Pappus’s Hexagon Theorem")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab30"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/introduction#ba30"
    }
  }, [_c('b', [_vm._v("c. 350")]), _vm._v(" Bakhshali Manuscript")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab31"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/introduction#ba31"
    }
  }, [_c('b', [_vm._v("415")]), _vm._v(" The Death of Hypatia")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab32"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/introduction#ba32"
    }
  }, [_c('b', [_vm._v("c. 650")]), _vm._v(" Zero")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab33"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/introduction#ba33"
    }
  }, [_c('b', [_vm._v("c. 800")]), _vm._v(" Alcuin’s "), _c('i', [_vm._v("Propositiones ad Acuendos Juvenes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab34"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/introduction#ba34"
    }
  }, [_c('b', [_vm._v("830")]), _vm._v(" Al-Khwarizmi’s "), _c('i', [_vm._v("Algebra")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab35"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/introduction#ba35"
    }
  }, [_c('b', [_vm._v("834")]), _vm._v(" Borromean Rings")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab36"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/introduction#ba36"
    }
  }, [_c('b', [_vm._v("850")]), _vm._v(" "), _c('i', [_vm._v("Ganita Sara Samgraha")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab37"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/introduction#ba37"
    }
  }, [_c('b', [_vm._v("c. 850")]), _vm._v(" Thabit Formula for Amicable Numbers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab38"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/introduction#ba38"
    }
  }, [_c('b', [_vm._v("c. 953")]), _vm._v(" "), _c('i', [_vm._v("Chapters in Indian Mathematics")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab39"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/introduction#ba39"
    }
  }, [_c('b', [_vm._v("1070")]), _vm._v(" Omar Khayyam’s "), _c('i', [_vm._v("Treatise")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab40"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/introduction#ba40"
    }
  }, [_c('b', [_vm._v("c. 1150")]), _vm._v(" Al-Samawal’s "), _c('i', [_vm._v("The Dazzling")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab41"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/introduction#ba41"
    }
  }, [_c('b', [_vm._v("c. 1200")]), _vm._v(" Abacus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab42"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/introduction#ba42"
    }
  }, [_c('b', [_vm._v("1202")]), _vm._v(" Fibonacci’s "), _c('i', [_vm._v("Liber Abaci")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap1#ba43",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1256")]), _vm._v(" Wheat on a Chessboard")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap1#ba44",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("c. 1350")]), _vm._v(" Harmonic Series Diverges")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap1#ba45",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("c. 1427")]), _vm._v(" Law of Cosines")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab46"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap1#ba46",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1478")]), _vm._v(" "), _c('i', [_vm._v("Treviso Arithmetic")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab47"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap1#ba47",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("c. 1500")]), _vm._v(" Discovery of Series Formula for π")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab48"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap1#ba48",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1509")]), _vm._v(" Golden Ratio")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab49"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap1#ba49",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1518")]), _vm._v(" "), _c('i', [_vm._v("Polygraphiae Libri Sex")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab50"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap1#ba50",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1537")]), _vm._v(" Loxodrome")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab51"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap1#ba51",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1545")]), _vm._v(" Cardano’s "), _c('i', [_vm._v("Ars Magna")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab52"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap1#ba52",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1556")]), _vm._v(" "), _c('i', [_vm._v("Sumario Compendioso")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab53"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap1#ba53",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1569")]), _vm._v(" Mercator Projection")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab54"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap1#ba54",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1572")]), _vm._v(" Imaginary Numbers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab55"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap1#ba55",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1611")]), _vm._v(" Kepler Conjecture")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab56"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap1#ba56",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1614")]), _vm._v(" Logarithms")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab57"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap1#ba57",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1621")]), _vm._v(" Slide Rule")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab58"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap1#ba58",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1636")]), _vm._v(" Fermat’s Spiral")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab59"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap1#ba59",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1637")]), _vm._v(" Fermat’s Last Theorem")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab60"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap1#ba60",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1637")]), _vm._v(" Descartes’ "), _c('i', [_vm._v("La Géométrie")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab61"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap1#ba61",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1637")]), _vm._v(" Cardioid")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab62"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap1#ba62",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1638")]), _vm._v(" Logarithmic Spiral")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab63"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap1#ba63",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1639")]), _vm._v(" Projective Geometry")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab64"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap1#ba64",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1641")]), _vm._v(" Torricelli’s Trumpet")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab65"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap1#ba65",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1654")]), _vm._v(" Pascal’s Triangle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab66"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap1#ba66",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1657")]), _vm._v(" The Length of Neile’s Semicubical Parabola")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab67"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap1#ba67",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1659")]), _vm._v(" Viviani’s Theorem")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab68"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap1#ba68",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("c. 1665")]), _vm._v(" Discovery of Calculus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab69"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap1#ba69",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1669")]), _vm._v(" Newton’s Method")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab70"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap1#ba70",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1673")]), _vm._v(" Tautochrone Problem")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab71"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap1#ba71",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1674")]), _vm._v(" Astroid")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab72"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap1#ba72",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1696")]), _vm._v(" L’Hôpital’s "), _c('i', [_vm._v("Analysis of the Infinitely Small")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab73"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap1#ba73",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1702")]), _vm._v(" Rope around the Earth Puzzle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab74"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap1#ba74",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1713")]), _vm._v(" Law of Large Numbers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab75"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap1#ba75",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1727")]), _vm._v(" Euler’s Number, "), _c('i', [_vm._v("e")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab76"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap1#ba76",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1730")]), _vm._v(" Stirling’s Formula")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab77"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap1#ba77",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1733")]), _vm._v(" Normal Distribution Curve")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab78"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap1#ba78",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1735")]), _vm._v(" Euler-Mascheroni Constant")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab79"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap1#ba79",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1736")]), _vm._v(" Königsberg Bridges")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab80"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap1#ba80",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1738")]), _vm._v(" St. Petersburg Paradox")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab81"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap1#ba81",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1742")]), _vm._v(" Goldbach Conjecture")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab82"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap1#ba82",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1748")]), _vm._v(" Agnesi’s "), _c('i', [_vm._v("Instituzioni Analitiche")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab83"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap1#ba83",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1751")]), _vm._v(" Euler’s Formula for Polyhedra")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab84"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap1#ba84",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1751")]), _vm._v(" Euler’s Polygon Division Problem")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab85"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap1#ba85",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1759")]), _vm._v(" Knight’s Tours")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab86"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap1#ba86",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1761")]), _vm._v(" Bayes’ Theorem")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab87"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap1#ba87",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1769")]), _vm._v(" Franklin Magic Square")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab88"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap1#ba88",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1774")]), _vm._v(" Minimal Surface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab89"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap1#ba89",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1777")]), _vm._v(" Buffon’s Needle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab90"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap1#ba90",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1779")]), _vm._v(" Thirty-Six Officers Problem")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab91"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap1#ba91",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("c. 1789")]), _vm._v(" Sangaku Geometry")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab92"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap1#ba92",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1795")]), _vm._v(" Least Squares")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab93"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap2#ba93",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1796")]), _vm._v(" Constructing a Regular Heptadecagon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab94"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap2#ba94",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1797")]), _vm._v(" Fundamental Theorem of Algebra")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab95"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap2#ba95",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1801")]), _vm._v(" Gauss’s "), _c('i', [_vm._v("Disquisitiones Arithmeticae")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab96"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap2#ba96",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1801")]), _vm._v(" Three-Armed Protractor")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab97"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap2#ba97",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1807")]), _vm._v(" Fourier Series")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab98"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap2#ba98",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1812")]), _vm._v(" Laplace’s "), _c('i', [_vm._v("Théorie Analytique des Probabilités")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab99"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap2#ba99",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1816")]), _vm._v(" Prince Rupert’s Problem")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab100"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap2#ba100",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1817")]), _vm._v(" Bessel Functions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab101"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap2#ba101",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1822")]), _vm._v(" Babbage Mechanical Computer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab102"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap2#ba102",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1823")]), _vm._v(" Cauchy’s "), _c('i', [_vm._v("Le Calcul Infinitésimal")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab103"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap2#ba103",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1827")]), _vm._v(" Barycentric Calculus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab104"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap2#ba104",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1829")]), _vm._v(" Non-Euclidean Geometry")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab105"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap2#ba105",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1831")]), _vm._v(" Möbius Function")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab106"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap2#ba106",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1832")]), _vm._v(" Group Theory")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab107"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap2#ba107",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1834")]), _vm._v(" Pigeonhole Principle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab108"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap2#ba108",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1843")]), _vm._v(" Quaternions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab109"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap2#ba109",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1844")]), _vm._v(" Transcendental Numbers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab110"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap2#ba110",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1844")]), _vm._v(" Catalan Conjecture")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab111"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap2#ba111",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1850")]), _vm._v(" The Matrices of Sylvester")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab112"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap2#ba112",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1852")]), _vm._v(" Four-Color Theorem")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab113"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap2#ba113",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1854")]), _vm._v(" Boolean Algebra")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab114"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap2#ba114",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1857")]), _vm._v(" Icosian Game")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab115"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap2#ba115",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1857")]), _vm._v(" Harmonograph")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab116"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap2#ba116",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1858")]), _vm._v(" The Möbius Strip")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab117"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap2#ba117",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1858")]), _vm._v(" Holditch’s Theorem")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab118"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap2#ba118",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1859")]), _vm._v(" Riemann Hypothesis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab119"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap2#ba119",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1868")]), _vm._v(" Beltrami’s Pseudosphere")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab120"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap2#ba120",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1872")]), _vm._v(" Weierstrass Function")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab121"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap2#ba121",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1872")]), _vm._v(" Gros’s "), _c('i', [_vm._v("Théorie du Baguenodier")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab122"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap2#ba122",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1874")]), _vm._v(" The Doctorate of Kovalevskaya")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab123"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap2#ba123",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1874")]), _vm._v(" Fifteen Puzzle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab124"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap2#ba124",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1874")]), _vm._v(" Cantor’s Transfinite Numbers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab125"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap2#ba125",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1875")]), _vm._v(" Reuleaux Triangle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab126"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap2#ba126",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1876")]), _vm._v(" Harmonic Analyzer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab127"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap2#ba127",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1879")]), _vm._v(" Ritty Model I Cash Register")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab128"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap2#ba128",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1880")]), _vm._v(" Venn Diagrams")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab129"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap2#ba129",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1881")]), _vm._v(" Benford’s Law")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab130"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap2#ba130",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1882")]), _vm._v(" Klein Bottle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab131"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap2#ba131",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1883")]), _vm._v(" Tower of Hanoi")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab132"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap2#ba132",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1884")]), _vm._v(" "), _c('i', [_vm._v("Flatland")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab133"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap2#ba133",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1888")]), _vm._v(" Tesseract")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab134"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap2#ba134",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1889")]), _vm._v(" Peano Axioms")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab135"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap2#ba135",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1890")]), _vm._v(" Peano Curve")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab136"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap2#ba136",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1891")]), _vm._v(" Wallpaper Groups")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab137"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap2#ba137",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1893")]), _vm._v(" Sylvester’s Line Problem")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab138"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap2#ba138",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1896")]), _vm._v(" Proof of the Prime Number Theorem")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab139"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap2#ba139",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1899")]), _vm._v(" Pick’s Theorem")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab140"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap2#ba140",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1899")]), _vm._v(" Morley’s Trisector Theorem")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab141"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap2#ba141",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1900")]), _vm._v(" Hilbert’s 23 Problems")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab142"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap2#ba142",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1900")]), _vm._v(" Chi-Square")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab143"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3#ba143",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1901")]), _vm._v(" Boy’s Surface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab144"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3#ba144",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1901")]), _vm._v(" Barber Paradox")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab145"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3#ba145",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1901")]), _vm._v(" Jung’s Theorem")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab146"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3#ba146",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1904")]), _vm._v(" Poincaré Conjecture")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab147"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3#ba147",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1904")]), _vm._v(" Koch Snowflake")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab148"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3#ba148",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1904")]), _vm._v(" Zermelo’s Axiom of Choice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab149"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3#ba149",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1905")]), _vm._v(" Jordan Curve Theorem")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab150"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3#ba150",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1906")]), _vm._v(" Thue-Morse Sequence")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab151"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3#ba151",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1909")]), _vm._v(" Brouwer Fixed-Point Theorem")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab152"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3#ba152",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1909")]), _vm._v(" Normal Number")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab153"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3#ba153",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1909")]), _vm._v(" Boole’s "), _c('i', [_vm._v("Philosophy and Fun of Algebra")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab154"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3#ba154",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1910–1913")]), _vm._v(" "), _c('i', [_vm._v("Principia Mathematica")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab155"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3#ba155",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1912")]), _vm._v(" Hairy Ball Theorem")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab156"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3#ba156",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1913")]), _vm._v(" Infinite Monkey Theorem")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab157"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3#ba157",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1916")]), _vm._v(" Bieberbach Conjecture")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab158"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3#ba158",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1916")]), _vm._v(" Johnson’s Theorem")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab159"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3#ba159",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1918")]), _vm._v(" Hausdorff Dimension")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab160"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3#ba160",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1919")]), _vm._v(" Brun’s Constant")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab161"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3#ba161",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("c. 1920")]), _vm._v(" Googol")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab162"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3#ba162",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1920")]), _vm._v(" Antoine’s Necklace")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab163"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3#ba163",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1921")]), _vm._v(" Noether’s "), _c('i', [_vm._v("Idealtheorie")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab164"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3#ba164",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1921")]), _vm._v(" Lost in Hyperspace")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab165"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3#ba165",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1922")]), _vm._v(" Geodesic Dome")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab166"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3#ba166",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1924")]), _vm._v(" Alexander’s Horned Sphere")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab167"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3#ba167",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1924")]), _vm._v(" Banach-Tarski Paradox")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab168"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3#ba168",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1925")]), _vm._v(" Squaring a Rectangle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab169"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3#ba169",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1925")]), _vm._v(" Hilbert’s Grand Hotel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab170"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3#ba170",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1926")]), _vm._v(" Menger Sponge")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab171"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3#ba171",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1927")]), _vm._v(" Differential Analyzer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab172"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3#ba172",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1928")]), _vm._v(" Ramsey Theory")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab173"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3#ba173",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1931")]), _vm._v(" Gödel’s Theorem")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab174"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3#ba174",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1933")]), _vm._v(" Champernowne’s Number")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab175"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3#ba175",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1935")]), _vm._v(" Bourbaki: Secret Society")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab176"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3#ba176",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1936")]), _vm._v(" Fields Medal")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab177"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3#ba177",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1936")]), _vm._v(" Turing Machines")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab178"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3#ba178",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1936")]), _vm._v(" Voderberg Tilings")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab179"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3#ba179",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1937")]), _vm._v(" Collatz Conjecture")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab180"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3#ba180",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1938")]), _vm._v(" Ford Circles")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab181"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3#ba181",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1938")]), _vm._v(" The Rise of Randomizing Machines")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab182"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3#ba182",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1939")]), _vm._v(" Birthday Paradox")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab183"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3#ba183",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("c. 1940")]), _vm._v(" Polygon Circumscribing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab184"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3#ba184",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1942")]), _vm._v(" Hex")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab185"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3#ba185",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1945")]), _vm._v(" Pig Game Strategy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab186"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3#ba186",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1946")]), _vm._v(" ENIAC")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab187"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3#ba187",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1946")]), _vm._v(" Von Neumann’s Middle-Square Randomizer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab188"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3#ba188",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1947")]), _vm._v(" Gray Code")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab189"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3#ba189",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1948")]), _vm._v(" Information Theory")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab190"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3#ba190",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1948")]), _vm._v(" Curta Calculator")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab191"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3#ba191",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1949")]), _vm._v(" Császár Polyhedron")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab192"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3#ba192",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1950")]), _vm._v(" Nash Equilibrium")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab193"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#ba193",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("c. 1950")]), _vm._v(" Coastline Paradox")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab194"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#ba194",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1950")]), _vm._v(" Prisoner’s Dilemma")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab195"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#ba195",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1952")]), _vm._v(" Cellular Automata")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab196"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#ba196",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1957")]), _vm._v(" Martin Gardner’s Mathematical Recreations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab197"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#ba197",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1958")]), _vm._v(" Gilbreath’s Conjecture")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab198"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#ba198",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1958")]), _vm._v(" Turning a Sphere Inside Out")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab199"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#ba199",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1958")]), _vm._v(" Platonic Billiards")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab200"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#ba200",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1959")]), _vm._v(" Outer Billiards")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab201"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#ba201",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1960")]), _vm._v(" Newcomb’s Paradox")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab202"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#ba202",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1960")]), _vm._v(" Sierpinski Numbers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab203"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#ba203",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1963")]), _vm._v(" Chaos and the Butterfly Effect")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab204"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#ba204",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1963")]), _vm._v(" Ulam Spiral")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab205"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#ba205",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1963")]), _vm._v(" Continuum Hypothesis Undecidability")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab206"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#ba206",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("c. 1965")]), _vm._v(" Superegg")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab207"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#ba207",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1965")]), _vm._v(" Fuzzy Logic")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab208"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#ba208",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1966")]), _vm._v(" Instant Insanity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab209"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#ba209",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1967")]), _vm._v(" Langlands Program")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab210"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#ba210",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1967")]), _vm._v(" Sprouts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab211"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#ba211",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1968")]), _vm._v(" Catastrophe Theory")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab212"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#ba212",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1969")]), _vm._v(" Tokarsky’s Unilluminable Room")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab213"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#ba213",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1970")]), _vm._v(" Donald Knuth and Mastermind")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab214"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#ba214",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1971")]), _vm._v(" Erdös and Extreme Collaboration")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab215"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#ba215",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1972")]), _vm._v(" HP-35: First Scientific Pocket Calculator")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab216"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#ba216",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1973")]), _vm._v(" Penrose Tiles")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab217"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#ba217",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1973")]), _vm._v(" Art Gallery Theorem")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab218"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#ba218",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1974")]), _vm._v(" Rubik’s Cube")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab219"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#ba219",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1974")]), _vm._v(" Chaitin’s Omega")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab220"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#ba220",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1974")]), _vm._v(" Surreal Numbers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab221"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#ba221",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1974")]), _vm._v(" Perko Knots")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab222"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#ba222",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1975")]), _vm._v(" Fractals")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab223"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#ba223",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1975")]), _vm._v(" Feigenbaum Constant")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab224"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#ba224",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1977")]), _vm._v(" Public-Key Cryptography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab225"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#ba225",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1977")]), _vm._v(" Szilassi Polyhedron")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab226"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#ba226",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1979")]), _vm._v(" Ikeda Attractor")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab227"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#ba227",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1979")]), _vm._v(" Spidrons")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab228"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#ba228",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1980")]), _vm._v(" Mandelbrot Set")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab229"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#ba229",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1981")]), _vm._v(" Monster Group")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab230"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#ba230",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1982")]), _vm._v(" Ball Triangle Picking")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab231"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#ba231",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1984")]), _vm._v(" Jones Polynomial")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab232"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#ba232",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1985")]), _vm._v(" Weeks Manifold")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab233"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#ba233",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1985")]), _vm._v(" Andrica’s Conjecture")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab234"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#ba234",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1985")]), _vm._v(" The "), _c('i', [_vm._v("ABC")]), _vm._v(" Conjecture")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab235"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#ba235",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1986")]), _vm._v(" Audioactive Sequence")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab236"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#ba236",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1988")]), _vm._v(" Mathematica")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab237"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#ba237",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1988")]), _vm._v(" Murphy’s Law and Knots")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab238"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#ba238",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1989")]), _vm._v(" Butterfly Curve")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab239"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#ba239",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1996")]), _vm._v(" The On-Line Encyclopedia of Integer Sequences")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab240"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#ba240",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1999")]), _vm._v(" Eternity Puzzle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab241"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#ba241",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1999")]), _vm._v(" Perfect Magic Tesseract")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab242"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#ba242",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1999")]), _vm._v(" Parrondo’s Paradox")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab243"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#ba243",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1999")]), _vm._v(" Solving of the Holyhedron")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab244"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#ba244",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("2001")]), _vm._v(" Bed Sheet Problem")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab245"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#ba245",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("2002")]), _vm._v(" Solving the Game of Awari")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab246"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#ba246",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("2002")]), _vm._v(" Tetris Is NP-Complete")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab247"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#ba247",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("2005")]), _vm._v(" "), _c('i', [_vm._v("NUMB3RS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab248"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#ba248",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("2007")]), _vm._v(" Checkers Is Solved")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab249"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#ba249",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("2007")]), _vm._v(" The Quest for Lie Group E"), _c('sub', [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ab250"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#ba250",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("2007")]), _vm._v(" Mathematical Universe Hypothesis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "ab251"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4#ba251",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes and Further Reading")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "ab253"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/index#ba253",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "ab252"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/index#ba252",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Photo Credits")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3",
    attrs: {
      "id": "ab254"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/abt#ba254",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a166910","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/toc.vue
// module id = 78
// module chunks = 0